import HighChart from 'components/highcharts/HighChart';
import { StyledChartWrapper, StyledColumnChart } from './ColumnChart.style';
import useChartConfig from './useChartConfig';
import VerticalMenu from 'components/VerticalMenu/VertcialMenu';

const ColumnChart = ({ forecast, chartType }) => {
  const columnChartConfig = useChartConfig({ forecast, chartType });

  return (
    <StyledColumnChart>
      <aside>
        <VerticalMenu
          options={chartType.options}
          value={chartType.key}
          onChange={chartType.onChange}
        />
      </aside>
      <StyledChartWrapper>
        <HighChart
          containerProps={{
            style: { width: '100%' }
          }}
          options={columnChartConfig}
        />
      </StyledChartWrapper>
    </StyledColumnChart>
  );
};

export default ColumnChart;
